<style lang="scss">
  @import "@/assets/scss/vuexy/pages/List.scss";
</style>
<template lang="html">
  <div>
    <div class="vx-row">
       <div class="vx-col w-full my-2">
        <vs-button color="primary" class="float-right" :to="'circuitos/add'">
          <span class="font-bold ml-2" >{{$t('Labels.Add')}}</span>
        </vs-button>
      </div>
    </div>
    <vx-card class="m-2">
    <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button  @click="showFilters = !showFilters"  type="flat" color="grey" class="float-right">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle mr-2"><iconFilter/></iconBase>
          <span v-show="!showFilters"  class="font-bold">{{$t('Labels.ShowFilters')}}</span>
          <span v-show="showFilters"  class="font-bold">{{$t('Labels.HideFilters')}}</span>
        </vs-button>
      </div>
    </div>
    <div class="vx-row my-5" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Name')}}</label>
        <vs-input class="w-full" v-model="filters.name" />
      </div>
      <div class="vx-col">
        <label  class="font-bold">{{$t('Labels.Cuantity')}}</label>
        <vs-slider v-model="filters.cuantity" :min="0" :max="maximum"/>
      </div>
      <div class="vx-col w-full text-center sm:inline-block sm:w-auto">
        <vs-button @click="getResponse()" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    </vx-card>
    <vx-card class="m-2">
    <div class="vx-row my-5">
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="columnOrders" v-model="filters.byColumn" :reduce="v => v.value"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder === 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder !== 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button>  
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0"> 
        <label class="font-bold align-middle mr-2">{{$t('Labels.ByPage')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="byPage" v-model="filters.limit" :reduce="v => v.value"/>
      </div>
    </div>
    <vs-table  v-if="response" :data="response"  v-model="selected" @selected="goToDetail">
      <template slot="thead">
        <vs-th>
          {{$t('Labels.Name')}}
        </vs-th>
        <vs-th>
          {{$t('Labels.Color')}}
        </vs-th>
        <vs-th>
          {{$t('Labels.LuminariesCount')}}
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="item" :key="index" @click="goToDetail(item.id)" v-for="(item, index) in data">
          <vs-td :data="item.name">
            {{item.name}}
          </vs-td>
          <vs-td :data="item.color">
            <div class="w-5 h-5 inline-block rounded-sm align-middle" :style="{ 'background-color': item.color }"></div>
            <div class="ml-2 inline-block align-middle">{{item.color || 'N/A'}}</div>
          </vs-td>
          <vs-td :data="item.total_devices">
            {{item.total_devices}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination class="mt-5" v-if="response" :max="3" :total="totalPages" v-model="currentx"></vs-pagination>
    </vx-card>
  </div>
</template>
<script>
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import listItem from '@/components/listItem/listItem.vue'
import statusItem from '@/components/statusItem/statusItem.vue'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'
import iconFilter from '@/components/icons/iconFilter'


export default {
  components: {
    listItem,
    statusItem,
    Datepicker,
    'v-select': vSelect,
    iconFilterDesc,
    iconFilterAsc,
    iconBase,
    iconFilter
  },
  data () {
    return {
      response: [],
      currentx: 1,
      totalPages: 0,
      selected:[],
      filters:{
        limit: 20,
        offset: 0,
        byColumn: 'name',
        byOrder: 'ASC',
        cuantity: [0, 0],
        name: null,
        uuid: this.$route.query.circuit !== undefined ? this.$route.query.circuit : null
      },
      columnOrders:[
        {label: this.$t('Labels.Name'), value: 'name'},
        {label: this.$tc('Labels.Cuantity', 0), value: 'total'}
      ],
      byColumn: 'updatedAt',
      byPage:[
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 75, value: 75},
        {label: 100, value: 100}
      ],
      showFilters: false,
      maximum: 0,
      initial: false
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()
      const filter = {}
      filter.limit = this.filters.limit
      filter.offset = this.filters.offset
      filter.byColumn = this.filters.byColumn
      filter.byOrder = this.filters.byOrder
      if (!this.initial) {
        filter.name = this.filters.name
        filter.uuid = this.filters.uuid
        filter.begin_account = this.filters.cuantity[0]
        filter.end_account = this.filters.cuantity[1]
      }

      
      const params = {
        url: 'luminaires_circuits',
        method: 'GET',
        params: filter
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        this.maximum = response.data.data.maximum
        this.setPages(response.data.data.count)
        if (this.initial) {
          this.filters.cuantity = [0, response.data.data.maximum]
        }
        this.initial = false
      }).catch(() => {
        this.response = []
        this.totalPages = 0
      }).finally(() => {
        this.$vs.loading.close()
        this.filterBeginEndLastSeen = false
      })
      
    },
    resetFilters () {
      this.filters.name = null
      this.filters.uuid = null
      this.filters.cuantity = [0, 0]
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getResponse()
    },
    relativeTimeConvert (date) {
      return this.$dayjs().to(this.$dayjs(date))
    },
    goToDetail (tr) {
      if (!empty(tr.uuid)) window.location.href = `/circuitos/${tr.uuid}`
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    }

  },
  created () {
    screen.width < '576' ? this.showFilters = false : this.showFilters = true
    this.initial = true
    this.getResponse()
  },
  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    }
  }
}
</script>